import {SET_MARKET_CAP} from '../../../constants/CommonConstants';
import {GeneralAction, SetMarketCapPayload} from '../../../@types/actions';

export const SetMarketCapAction = (data: SetMarketCapPayload): GeneralAction<SetMarketCapPayload> => ({
    type: SET_MARKET_CAP,
    payload: data
});
